import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import Bg from '../../images/shapes/memecoin_bg_shape_1.svg'
import Bg2 from '../../images/shapes/btn_mask_bg.png'
import shape2 from '../../images/shapes/shape_circle_zigzag.svg'
import shape3 from '../../images/shapes/shape_chain_1.svg'
import shape4 from '../../images/shapes/shape_chain_2.svg'
import Modal from '../Modal/Modal';


const Hero2 = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <section className="memecoin_hero_section section_decoration text-center" style={{ backgroundImage: `url(${Bg})` }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <h5 data-aos="fade-up" data-aos-duration="800">Brands Don't Wait.</h5>
              <h1 className="hero_title text-uppercase" data-aos="fade-up" data-aos-duration="800">
                Get the <mark>Logo</mark> and <mark>Website</mark> That Gets You Taken Seriously.
              </h1>
              <p className="hero_description" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                The perfect opportunity to make your brand stand out. Get your work done while adhering to affordable prices.
              </p>
              <ul className="btns_group unordered_list justify-content-center p-0" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
                <li>
                  <Link className="memecoin_btn bg-white" to="/">
                    <span className="btn_label">Explore Pre-made logos</span>
                    <span className="btn_bg" style={{ maskImage: `url(${Bg2})` }}></span>
                  </Link>
                </li>
                <li>
                  <button className="memecoin_btn bg-light" onClick={openModal}>
                    <span className="btn_label">Get a Free Quote</span>
                    <span className="btn_bg" style={{ maskImage: `url(${Bg2})` }}></span>
                  </button>
                </li>
              </ul>

              <AnchorLink className="scrollspy_btn scroll_down" href='#id_token_offer'>
                <i className="fa-solid fa-chevron-down"></i>
                <i className="fa-solid fa-chevron-down"></i>
                <i className="fa-solid fa-chevron-down"></i>
                <img className="spin_image" src={shape2} alt="Zigzag" />
              </AnchorLink>
            </div>
          </div>
        </div>
        <div className="decoration_item shape_chain_1">
          <img src={shape3} alt="Shape Chain" />
        </div>
        <div className="decoration_item shape_chain_2">
          <img src={shape4} alt="Shape Chain" />
        </div>
      </section>
      {isModalOpen && <Modal onClose={closeModal} />}
    </>
  )
}

export default Hero2;